import { useContext } from 'react';
import { useStore } from 'zustand';
import { type IDV2Store, StoreContext } from '@/idv2/features/idv-to-idv2/idv2-provider';

/**
 * Rethrows a superseded session during render, which is what reaches the router's errorComponent —
 * error boundaries don't catch the async rejection the request failed with.
 */
export const useThrowIfSuperseded = () => {
  const store = useContext(StoreContext);
  if (!store) {
    throw new Error("useThrowIfSuperseded must be used within Idv2Provider");
  }
  const error = useStore(store, _temp);
  if (error) {
    throw error;
  }
};
function _temp(state) {
  return state.supersededError;
}